import { newRequest } from '../helpers/axios'

export default function getDepartments(fetchAll = false) {
  if (fetchAll) {
    // retrieves all departments regardless of isActive status
    return newRequest('GET', '/users/all_departments', null, null, null)
  }
  return newRequest('GET', '/users/departments', null, null, 'nodepartment')
}
